import config from '../config';
import {
  authHeader,
  customFetch,
  handleResponse,
  jsonHeader,
  commonRequestOptions,
} from '../helpers';

const endpointPath = config.api.API_URL + '/attribute_sensitivity';

export const attributeSensitivityService = {
  getAll,
  create,
  update,
  checkDestroy,
  destroy,
};

function getAll(signal) {
  const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
  return customFetch(`${endpointPath}/all`, requestOptions, signal).then(handleResponse);
}

function create(items, signal) {
  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      ...jsonHeader(),
    },
    ...commonRequestOptions(),
    body: JSON.stringify(items),
  };

  return customFetch(`${endpointPath}`, requestOptions, signal).then(handleResponse);
}

function update(items, signal) {
  const requestOptions = {
    method: 'PUT',
    headers: {
      ...authHeader(),
      ...jsonHeader(),
    },
    ...commonRequestOptions(),
    body: JSON.stringify(items),
  };

  return customFetch(`${endpointPath}`, requestOptions, signal).then(handleResponse);
}

function checkDestroy(items, signal) {
  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      ...jsonHeader(),
    },
    ...commonRequestOptions(),
    body: JSON.stringify(items),
  };

  return customFetch(`${endpointPath}/check_delete`, requestOptions, signal).then(handleResponse);
}

function destroy(items, signal) {
  const requestOptions = {
    method: 'DELETE',
    headers: {
      ...authHeader(),
      ...jsonHeader(),
    },
    ...commonRequestOptions(),
    body: JSON.stringify(items),
  };

  return customFetch(`${endpointPath}`, requestOptions, signal).then(handleResponse);
}
